(function (xhrRequest: any): void {
    type openPrototype = (method: string, url: string, async?: boolean, user?: string, password?: string) => void;
    type sendPrototype = (data: any) => void;

    const open: openPrototype = xhrRequest.prototype.open as openPrototype;
    const send: sendPrototype = xhrRequest.prototype.send as sendPrototype;

    function getParameterByName(name: string): string {
        let url: string = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex: RegExp = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        let results: any = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return "";
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    xhrRequest.prototype.open = function (method: string, url: string, async?: boolean, user?: string, password?: string): void {
        this.GetMethod = function (): string {
            return method.toUpperCase();
        };

        MSTrgovina.Common.Spinner.Start();

        return open.apply(this, arguments);
    };

    xhrRequest.prototype.send = function (data: any): any {
        if (typeof this.GetMethod === "function") {
            let method: string = this.GetMethod();

            switch (method) {
                case "POST":
                case "PUT":
                case "PATCH":
                case "DELETE": {
                    const token: string = $("#appConstants input[name=AntiforgeryToken]").val() as string;
                    //let token: string = Common.Cookies.getCookie("XSRF-TOKEN");
                    this.setRequestHeader("X-CSRF-TOKEN", token);
                    break;
                }
                default:
                    // other request methods don't require AntiForgeryToken
                    break;
            }
        } else {
            throw new Error("Can't determine HTTP Method. Something went wrong!");
        }

        //// add page id header
        //let pageId: string = (<any>document).PageID;
        //this.setRequestHeader("X-page-id", pageId);

        //this.setRequestHeader("X-Is-Ajax", "true");

        //// add main entity id header
        //let mainEntityID: string = (<any>document).App_MainEntityID;
        //if (mainEntityID !== null && mainEntityID !== "") {
        //    this.setRequestHeader("X-main-entity-id", mainEntityID);
        //}

        const xhr: XMLHttpRequest = this;

        function HandleRewriteUrlRequest(): void {
            if (xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED) {

                // rewrite url
                let rewriteUrl: string = xhr.getResponseHeader("X-rewrite-url-to");

                // get MesageBox items
                let messageBoxItemsBase64: string = xhr.getResponseHeader("X-MessageBox-Items");

                // redirect url
                let redirectUrl: string = xhr.getResponseHeader("X-redirect-url-to");
                if (redirectUrl !== null && redirectUrl !== "") {
                    if (messageBoxItemsBase64 !== null && messageBoxItemsBase64 !== "") {
                        localStorage.setItem("X-MessageBox-Items", messageBoxItemsBase64);
                    }

                    window.location.href = redirectUrl;
                } else {
                    //// rewrite url
                    //if (rewriteUrl !== null && rewriteUrl !== "") {
                    //    let currentState: any = history.state;

                    //    history.replaceState(currentState, document.title, rewriteUrl);

                    //    (<any>document).App_MainEntityID = getParameterByName("MainEntityID");
                    //}

                    //// MesageBox items
                    //if (messageBoxItemsBase64 !== null && messageBoxItemsBase64 !== "") {
                    //    let items: string = Nrl.Common.EncodingHelper.b64DecodeUnicode(messageBoxItemsBase64);
                    //    let itemsObj: any[] = JSON.parse(items);

                    //    for (let i: number = 0; i < itemsObj.length; i++) {
                    //        let item: any = itemsObj[i];

                    //        Nrl.Common.MessageBox.ShowMessage(
                    //            item.Title,
                    //            item.Message,
                    //            <any>Nrl.Common.MessageBox.MessageType[item.MessageType],
                    //            item.TimeOut
                    //        );
                    //    }
                    //}

                }

                xhr.removeEventListener("readystatechange", HandleRewriteUrlRequest);
            }
        }

        function HandleRequestEnded(): void {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                let popupCallbackBase64: string = xhr.getResponseHeader("X-popup-callback-function");

                // // get custom exception header
                // let exceptionTypeHeader: string = xhr.getResponseHeader("X-exception-type");
                // let request: any = xhr;
                // if (exceptionTypeHeader === Nrl.Common.Enums.ExceptionTypes.BusinessException
                //    && (request.GetMethod() !== "DELETE" && request.GetMethod() !== "PUT")
                //    && xhr.response !== null && xhr.response !== "") {
                //    let errorMessageItem: any = JSON.parse(xhr.response);

                //    if (errorMessageItem.error === true) {
                //        Nrl.Common.MessageBox.ShowMessage(
                //            "",
                //            errorMessageItem.message,
                //            <any>Nrl.Common.MessageBox.MessageType.Error,
                //            10
                //        );
                //    }
                // }

                if (popupCallbackBase64 !== null && popupCallbackBase64 !== "") {
                   let callbackString: string = MSTrgovina.Common.Helpers.EncodingHelper.b64DecodeUnicode(popupCallbackBase64);
                   let callbackFunction: any = MSTrgovina.Common.Helpers.EvalHelper.GetFunction(callbackString);

                   if (callbackFunction) {
                       callbackFunction(xhr.responseText);
                   }
                }

                //// handle file download
                //let contentDisposition: string = xhr.getResponseHeader("content-disposition");
                //if (typeof contentDisposition !== "undefined" && contentDisposition !== null && contentDisposition !== "") {
                //    let contentType: string = xhr.getResponseHeader("content-type");
                //    let blob: any = new Blob([xhr.response], <BlobPropertyBag>{ type: contentType });
                //    let filename: string;
                //    if (contentDisposition && contentDisposition.indexOf("attachment") !== -1) {
                //        let filenameRegex: RegExp = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                //        let matches: RegExpExecArray = filenameRegex.exec(contentDisposition);
                //        if (matches != null && matches[1]) {
                //            filename = matches[1].replace(/['"]/g, "");
                //        }
                //    }
                //    (<any>window).saveAs(blob, filename);
                //}

                //Nrl.Common.Validation.ReAttachValidationMutationObservers();
                MSTrgovina.Common.Spinner.Stop();

                xhr.removeEventListener("readystatechange", HandleRequestEnded);
            }
        }

        xhr.addEventListener("readystatechange", HandleRewriteUrlRequest, false);
        xhr.addEventListener("readystatechange", HandleRequestEnded, false);

        return send.apply(this, arguments);
    };

})(XMLHttpRequest);
